var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:(_vm.styles),attrs:{"src":_vm.imageSrc,"alt":"icon"}})
}
var staticRenderFns = []

export { render, staticRenderFns }